$ ->
  if $("body.databases.index").length > 0
    assign_databases_search_submit()
    assign_databases_search_key_up()
    assign_databases_click_actions()
    unless $("#database_name").size() == 0 || $("#database_name").val().trim() == ""
      window.find_databases_request.abort() if window.find_databases_request
      window.find_databases_request = $.get($('#databases_search').attr('action'), $('#databases_search').serialize(), null, 'script')

@assign_databases_search_submit = () ->
  $('#databases_search').submit(() ->
    window.find_databases_request.abort() if window.find_databases_request
    window.find_databases_request = $.get(this.action, $(this).serialize(), null, 'script')
    false
  )

@assign_databases_search_key_up = () ->
  $('#databases_search input').keyup( () ->
    window.find_databases_request.abort() if window.find_databases_request
    window.find_databases_request = $.get($('#databases_search').attr('action'), $('#databases_search').serialize(), null, 'script')
    false
  )

@assign_databases_click_actions = () ->
  assign_clickable_row_actions()
  links = $('#databases th a, #databases .pagination a, #databases_search a')
  links.off('click')
  links.on('click', () ->
    $.getScript(this.href)
    false
  )
